import { useEffect } from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/auth/AuthProvider";

export function LoginPage() {
  const { user, loading } = useAuth();
  const [params] = useSearchParams();

  const callbackUrl = params.get("callbackUrl") || "/dashboard";
  const error = params.get("error");

  useEffect(() => {
    if (!loading && user) {
      // in-app redirect handled below
    }
  }, [loading, user]);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (user) return <Navigate to={callbackUrl} replace />;

  const loginHref = `/api/auth/login?callbackUrl=${encodeURIComponent(
    callbackUrl
  )}`;

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 p-4">
      <div className="w-full max-w-md rounded-2xl border bg-card p-8 shadow-sm">
        <div className="mb-8 text-center">
          <img
            src="/logo.png"
            alt="CloudStudio"
            className="mb-3 h-12 w-12 rounded-xl"
          />
          <h1 className="text-2xl font-semibold tracking-tight">
            CloudStudio Command Center
          </h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Internal admin dashboard
          </p>
        </div>

        {error && (
          <div className="mb-4 rounded-md border border-destructive/50 bg-destructive/10 px-4 py-3 text-sm text-destructive">
            {error === "AccessDenied"
              ? "You must sign in with a @cloudcampaign.com email."
              : "Sign-in failed. Please try again."}
          </div>
        )}

        <a
          href={loginHref}
          className="flex w-full items-center justify-center gap-3 rounded-lg border bg-white px-4 py-2.5 text-sm font-medium shadow-sm transition hover:bg-slate-50"
        >
          <svg className="h-5 w-5" viewBox="0 0 24 24">
            <path
              fill="#4285F4"
              d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
            />
            <path
              fill="#34A853"
              d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
            />
            <path
              fill="#FBBC05"
              d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
            />
            <path
              fill="#EA4335"
              d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
            />
          </svg>
          Sign in with Google
        </a>

        <p className="mt-6 text-center text-xs text-muted-foreground">
          Access restricted to cloudcampaign.com accounts
        </p>
      </div>
    </div>
  );
}
